import React, { useEffect } from "react";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import { styled } from "@mui/material/styles";
import ValidationAccordionComp from '../utilities/ValidationAccordion/ValidationAccordian';
import check from "../../images/checkIcon.svg";
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import RedoIcon from '@mui/icons-material/Redo';
import {
  Box,
  Container,
  FormControlLabel,
  FormGroup,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import AccordionComp, { Accordion } from "../utilities/Accordian/Accordian";
import {
  CreateRequestWrapper,
  ViewBoxWrapper,
  CalculationWrapper,
} from "./CountryUploadValidationstyled";
import { Content, CheckboxLabels, Constant, OpportunityType } from "./Content";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CustomButton from "../utilities/Button/Button";
import Button from "@mui/material/Button";
import Banner from "../utilities/Banner/Banner";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import SaveIcon from "@mui/icons-material/Save";
import ViewTable from "../utilities/ViewTable/ViewTable";
import Checkbox from "@mui/material/Checkbox";
import FooterButtons from "../utilities/FooterButtons/FooterButton";
import Validation from "../../Helper/Validation";
import Notification from "../utilities/Notification/Notification";
import InputAdornment from "@mui/material/InputAdornment";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import CheckIcon from "@mui/icons-material/Check";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { useSelector, useDispatch } from "react-redux";
import { Congiguration } from "../../Constants/AppConstants";
import {
  saveOpportunityDetails,
  saveCountryHeadCount,
  getAllInPrice,
  saveQuoteDetails,
  getServiceDistribution,
} from "../../Actions/QuoteAction";
import { getProductDetails } from "../../Actions/ProductAction";
import moment from "moment";
import { isEmpty } from "lodash";
import { read, utils } from "xlsx";
import { useNavigate } from "react-router-dom";
import ServiceDistribution from "./ServiceDistribution";

let quote = {
  quoteId: "",
  oppurtunityId: "",
  oppurtunity: "",
  oppurtunityName: "",
  quoteName: "",
  accountName: "",
  accountId: "",
  oppurtunityType: "",
  member: "",
  referrerName: "",
  commission: 0,
  percentagePaid: 0,
  discount: 0,
  currencyId: 0,
  existingPartneredClientInfo: "",
  noOfLivesSavedByPartner: "",
  totalPotentialHeadCountOutside: 0,
  formalRFPNotes: "",
  competitorsBidders: "",
  pastQuotes: "",
  currentUtilizationWithOtherVendors: "",
  deadline: null,
  noOfRAMs: 0,
  locationRAMs: "",
  samPriceRecommendAssumption: "",
  productId: 0,
  productVariationId: 0,
  componentIds: "",
  sessions: 0,
  utilization: 0,
  pricingStructureId: 0,
  hours: 0,
  additionalNotes: "",
  currentRateEffectiveOn: "",
  pastThreeYrRateHeadCount: "",
  estimatedNoOfAMHrPerYear: "",
  annualUtilizationThreeYrs: "",
  quoteStatusId: 0,
  accountManagerName: "",
  amHours: 0,
  userId: 0,
  companyId: 0,
};
const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const countrydataheader=["Country","Headcount","CPQ Correction","CPQ error"]
const countrydata=[
    ["UK","1,000","United Kingdom",true],
["US","1,000","United States",true],
["Tokyo","1,000","Tokyo",false]];
const  countrylist=["UK","US","Tokyo"]
const user = {
  user: {
    id: 1,
    firstName: "Sushil",
    lastName: "Pradhan",
    email: "sushil.kp@workplaceoptions.com",
    isActive: false,
    companyId: 0,
    createdBy: 0,
    createdDate: "0001-01-01T00:00:00",
    lastModifiedBy: 0,
    lastModifiedDate: "0001-01-01T00:00:00",
  },
  userRole: [
    {
      id: 1,
      roleName: "Accounting Team",
      description: "",
      isActive: false,
    },
    {
      id: 3,
      roleName: "Pricing Team",
      description: "",
    },
  ],
  userAction: [
    {
      id: 1,
      actionName: "Quote Creation",
    },
    {
      id: 2,
      actionName: "Save As Draft",
    },
    {
      id: 3,
      actionName: "Edit Quote",
    },
  ],
};

const crmData={
  account: "TestCPQ",
  accountNumber: "A12701",
  accountId: "8e3ac2e6-c352-ee11-be6f-0022482a90a6",
  opportunity: "OP-004513",
  opportunityId: "4b32ff2f-c552-ee11-be6f-0022482a90a6",
  opportunityReferrerName: "TestCPQ",
  opportunityType: "New Business",
  opportunityName: "Test-CPQ-OPR",
  programStartDate: "9/6/2023",
  commissionPercentage: null,
  isBroker: "Yes",
  wpo_currencyName: "US Dollar",
  billingCountry: "Australia",
  wpo_memberoftext: "Testing",
  currencyCode: "USD",
  accountSubType: "Client - B2B",
  accountOwner: "CRM Read Only #",
  accountOwnerMail: "CRMReadOnly@workplaceoptions.onmicrosoft.com",
  populationDetails: [
      {
          country: "Australia",
          headCount: 5000
      }
  ]
};
const CountryUploadValidation = () => {
  const { state } = useLocation();
  const loggedUser = (user);
  const [formValues, setFormValues] = useState({ ...quote });
  const [productDetails, setProductDetails] = useState({});
  const [productsList, setProductsList] = useState([]);
  const [productVariationsList, setProductVariationsList] = useState([]);
  const [pricingStructureList, setPricingStructureList] = useState([]);
  const [componentList, setComponentList] = useState([]);
  const [showVariationAccordian, setShowVariationAccordian] = useState(false);
  const [editMode, setEditMode] = useState(true);
  const [pricingStructureLbl, setPricingStructureLbl] = useState("");
  const [pricingStructureUSDLbl, setPricingStructureUSDLbl] = useState("");
  const [pricingStructureVal, setPricingStructureVal] = useState("");
  const [pricingStructureUSDVal, setPricingStructureUSDVal] = useState("");

  const [errors, setErrors] = useState({});
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState("");
  const [utilizationDistributionHeaders, setUtilizationDistributionHeaders] =
    useState([]);
  const [utilizationDistributionRows, setUtilizationDistributionRows] =
    useState([]);

  const [sumHeadCounts, setSumHeadCounts] = useState(null);
  const [showCommentText, setShowCommentText] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const optype = OpportunityType.find(
    (x) => x.crmOpportunityType === crmData.opportunityType
  );
  useEffect(() => {
    if (loggedUser && crmData) {
        const myDate = moment(crmData.programStartDate).format("YYYY-MM-DDT00:00:00.000") + "Z";

      const opportunity = {
        oppurtunityId: crmData.opportunityId,
        oppurtunity: crmData.opportunity,
        oppurtunityName: crmData.opportunityName,
        oppurtunityType: optype.cpqOpportunityType,
        oppurtunityReferrerName: crmData.opportunityReferrerName,
        accountName: crmData.account,
        programStartDate: myDate,
        commissionPercent: crmData.commissionPercentage
          ? crmData.commissionPercentage.toString()
          : "",
        isBroker: crmData.isBroker === "Yes" ? true : false,
        memberOf: crmData.wpo_memberoftext,
        currencyCode: crmData.currencyCode,
        accountSubType: crmData.accountSubType,
        accountOwner: crmData.accountOwner,
        accountOwnerEmail: crmData.accountOwnerMail,
        companyId: Congiguration.CompanyId,
        userId: loggedUser.user.id,
      };

      setFormValues((prevFormValues) => ({
        ...prevFormValues,
        oppurtunityId: crmData.opportunityId,
        userId: loggedUser.user.id,
        companyId: Congiguration.CompanyId,
        accountName: crmData.account,
        oppurtunityType: optype.cpqOpportunityType,
      }));

      dispatch(saveOpportunityDetails(opportunity))
        .then((data) => {
          setFormValues((prevFormValues) => ({
            ...prevFormValues,
            currencyId: data,
            oppurtunityId: crmData.opportunityId,
            userId: loggedUser.user.id,
            companyId: Congiguration.CompanyId,
            accountName: crmData.account,
          }));
          if (
            state?.requestType === "Create" &&
            crmData?.populationDetails !== null
          ) {
            const countryHeadCount = {
              countryHeadCountType: crmData.populationDetails.map((item) => {
                return {
                  countryName: item.country,
                  headCount: item.headCount,
                };
              }),
              oppurtunityId: crmData.opportunityId,
              userId: loggedUser.user.id,
              companyId: Congiguration.CompanyId,
            };
            // UploadCountries(countryHeadCount);
          }
        })
        .catch((e) => {
          console.log(e);
        });
      if (isEmpty(productDetails)) {
        dispatch(getProductDetails())
          .then((data) => {
            setProductDetails({ ...data });
            setProductsList([...data.products]);
          })
          .catch((e) => {
            console.log(e);
          });
      }
    }
  }, []);

  function UploadCountries(countryHeadCount) {
    dispatch(saveCountryHeadCount(countryHeadCount))
      .then((data) => {
        setFormValues((prevFormValues) => ({
          ...prevFormValues,
          quoteId: data,
        }));
        setNotificationMessage("Country Headcount uploaded successfully");
        setShowNotification(true);
        const headCount = countryHeadCount.countryHeadCountType.reduce(
          (accumulator, object) => {
            return accumulator + object.headCount;
          },
          0
        );
        setSumHeadCounts(headCount);
      })
      .catch((e) => {
        console.log(e);
      });
  }

  //useEffect(() => {
  //    // Make an API request to fetch product details
  //    axios
  //        .get('https://localhost:7186/ProductDetails/GetProductDetails?companyId=1')
  //        .then((response) => {
  //            // Assuming the response data is an object with a "products" array
  //            const productDetails = response.data.products;

  //            // Extract product names from the productDetails array
  //            const productNames = productDetails.map((product) => product.productName);

  //            // Set the productOptions state with the product names
  //            setProductOptions(productNames);
  //        })
  //        .catch((error) => {
  //            console.error('Error fetching data:', error);
  //        });
  //}, []);

  //const handleSelect = (selectedValue) => {
  //    // Clear the error and set the correct icon
  //    setErrors((prevErrors) => ({
  //        ...prevErrors,
  //        selectedOption: null,
  //    }));
  //    setSelectedOption(selectedValue);
  //    // If you have other logic based on the selected option, you can handle it here.

  //    setFormValues((prevFormValues) => ({
  //        ...prevFormValues,
  //        selectedOption: selectedValue,
  //    }));
  //};

  // Form Values State Set

  //const [formValues, setFormValues] = useState({
  //    numbercount: '',
  //    pastquotes: '',
  //    currentutlization: '',
  //    numberram: '',
  //    sampricing: '',
  //    deadlineDate: '',
  //    selectedOption: '',
  //    session: '',
  //    pricingOption: '',
  //    utilizationNumber: '',

  //});
  const handleClick = (event) => {
    setShowCommentText(event.target.checked);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;

    // Update the form values
    setFormValues((prevFormValues) => ({
      ...prevFormValues,
      [name]: value,
    }));

    // Validate the field and update the errors
    const validationErrors = Validation({ [name]: value });
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: validationErrors[name],
    }));
  };

  const handleSelectChange = (event) => {
    const { name, value } = event.target;
    setFormValues((prevFormValues) => ({
      ...prevFormValues,
      [name]: value,
    }));

    switch (name) {
      case "productId":
        setProductVariationsList([
          ...productDetails.productVariations.filter(
            (x) => x.productId === value
          ),
        ]);
        setPricingStructureList([
          ...productDetails.pricingStructures.filter(
            (x) => x.productId === value
          ),
        ]);
        break;
      case "productVariationId":
        if (value === 0) {
          setShowVariationAccordian(false);
        } else {
          setShowVariationAccordian(true);
          setComponentList([
            ...productDetails.components.filter(
              (x) => x.productVariationId === value
            ),
          ]);
          getUtilizationDistribution(value);
        }
        break;
      case "pricingStructureId":
        const obj = pricingStructureList.find((x) => x.id === value);
        setPricingStructureLbl(
          obj.pricingStructureName +
            ` ${crmData.currencyCode === "USD" ? "" : crmData.currencyCode}`
        );
        setPricingStructureUSDLbl(obj.pricingStructureName + " USD");
        break;

      default:
        break;
    }
  };

  function getUtilizationDistribution(productVariationId) {
    dispatch(
      getServiceDistribution(
        Congiguration.CompanyId,
        formValues.productId,
        productVariationId,
        formValues.quoteId
      )
    )
      .then((data) => {
        bindServiceDistribution(data);
      })
      .catch((e) => {
        console.log(e);
      });
  }

  function bindServiceDistribution(utilizationDistributionData) {
    const headers = [];
    const rows = [];
    const headerSet = new Set(["Country", "Product", "Product variation"]);
    const groupByCountry = groupBy(
      utilizationDistributionData,
      ({ countryId }) => countryId
    );

    const gridData = [];

    let index = 0;
    groupByCountry.forEach(function (item) {
      const componentUtilization = [];
      item.forEach(function (property) {
        componentUtilization.push([
          property.componentId,
          property.componentName,
          property.utilizationPercent,
        ]);
      });
      gridData.push([
        item[index++].countryId,
        item[index].countryName,
        item[index].productId,
        item[index].productName,
        item[index].productVariationId,
        item[index].productVariationName,
        componentUtilization,
      ]);
    });

    for (let i = 0; i < gridData.length; i++) {
      const componentsUtilizationPercent = [];
      gridData[i][6].forEach(function (component) {
        headerSet.add(component[1]);
        componentsUtilizationPercent.push(component[2]);
      });

      rows.push(
        [gridData[i][1], gridData[i][3], gridData[i][5]].concat(
          componentsUtilizationPercent
        )
      );
    }

    headerSet.forEach(function (item) {
      headers.push(item);
    });
    setUtilizationDistributionHeaders(headers);
    setUtilizationDistributionRows(rows);
  }

  function groupBy(list, keyGetter) {
    const map = new Map();
    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return map;
  }

  const handleCalculateClick = () => {
    const obJCalculate = {
      opportunityId: formValues.oppurtunityId,
      quoteId: formValues.quoteId,
      userId: loggedUser.user.id,
      numberOfSessionModels: formValues.sessions,
      utilization: formValues.utilization,
      productId: formValues.productId,
      productVariationId: formValues.productVariationId,
      requestedCurrencyId: formValues.currencyId,
      commission: formValues.commission,
      discount: formValues.discount,
      oppurtunityType: optype.cpqOpportunityType,
      amHoursUI: formValues.amHours,
      productHours: formValues.hours,
      companyId: Congiguration.CompanyId,
    };
    dispatch(getAllInPrice(obJCalculate))
      .then((data) => {
        console.log("calc", data);
        let alInPrice = {};

        if (data.length) {
          alInPrice = { ...data[data.length - 1] };
        }

        switch (formValues.pricingStructureId) {
          case 1:
            setPricingStructureVal(
              `${crmData.currencyCode} - ${alInPrice?.ffsReqCurrency
                .toString()
                .match(/^\d+(?:\.\d{0,2})?/)}`
            );
            setPricingStructureUSDVal(
              `USD - ${alInPrice?.ffsAnnualUSD
                .toString()
                .match(/^\d+(?:\.\d{0,2})?/)}`
            );
            break;
          case 2:
            setPricingStructureVal(
              `${crmData.currencyCode} - ${alInPrice?.flatFeeAnnualReqCurrency
                .toString()
                .match(/^\d+(?:\.\d{0,2})?/)}`
            );
            setPricingStructureUSDVal(
              `USD - ${alInPrice?.flatFeeAnnualUSD
                .toString()
                .match(/^\d+(?:\.\d{0,2})?/)}`
            );
            break;
          case 3:
            setPricingStructureVal(
              `${crmData.currencyCode} - ${alInPrice?.flatFeeMonthlyReqCurrency
                .toString()
                .match(/^\d+(?:\.\d{0,2})?/)}`
            );
            setPricingStructureUSDVal(
              `USD - ${alInPrice?.flatFeeMonthlyUSD
                .toString()
                .match(/^\d+(?:\.\d{0,2})?/)}`
            );
            break;
          case 4:
            setPricingStructureVal(
              `${crmData.currencyCode} - ${alInPrice?.pepm
                .toString()
                .match(/^\d+(?:\.\d{0,2})?/)}`
            );
            setPricingStructureUSDVal(
              `USD - ${alInPrice?.pepmusd
                .toString()
                .match(/^\d+(?:\.\d{0,2})?/)}`
            );
            break;
          case 5:
            setPricingStructureVal(
              `${crmData.currencyCode} - ${alInPrice?.pepy
                .toString()
                .match(/^\d+(?:\.\d{0,2})?/)}`
            );
            setPricingStructureUSDVal(
              `USD - ${alInPrice?.pepyusd
                .toString()
                .match(/^\d+(?:\.\d{0,2})?/)}`
            );
            break;

          default:
            setPricingStructureVal("");
            setPricingStructureUSDVal("");
            break;
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };
  const [bannerHeading, setBannerHeading] = useState(0);
  const [countryUploaded, setCountryUploaded] = useState(null);
  const handleFile = async (e) => {
    const file = e.target.files[0];
    const data = await file.arrayBuffer();

    /* parse */
    const wb = read(data);

    const ws = wb.Sheets[wb.SheetNames[0]]; // get the first worksheet
    const filedata = utils.sheet_to_json(ws);
    const countryUpload = {
      countryHeadCountType: filedata.map((item) => {
        return {
          countryName: item.Country,
          headCount: item.Headcount,
        };
      }),
      oppurtunityId: crmData.opportunityId,
      userId: loggedUser.user.id,
      companyId: Congiguration.CompanyId,
    };
    UploadCountries(countryUpload);
    console.log("wb", filedata);
    setBannerHeading(1);
    setCountryUploaded(file);
  };

  const handleSaveAsDraft = (event) => {
    event.preventDefault();
    const objQuote = { ...formValues };
    objQuote.quoteStatusId = 8;
    dispatch(saveQuoteDetails(objQuote))
      .then((data) => {
        console.log("drft qte", data);
        navigate("/viewquote", {
          state: {
            quoteId: formValues.quoteId,
          },
        });
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const objQuote = { ...formValues };
    objQuote.quoteStatusId = 1;
    dispatch(saveQuoteDetails(objQuote))
      .then((data) => {
        console.log("sv qte", data);
        navigate("/viewquote", {
          state: {
            quoteId: formValues.quoteId,
          },
        });
      })
      .catch((e) => {
        console.log(e);
      });

    //setErrors(Validation(formValues));

    //// Validate the form fields and set errors if validation fails
    //const validationErrors = Validation(formValues);

    //if (Object.keys(validationErrors).length > 0) {
    //    setErrors(validationErrors);
    //    setShowNotification(true);
    //    setNotificationMessage('Please fill in all required fields.');
    //} else {
    //    // If there are no validation errors, hide the notification popup
    //    setShowNotification(false);

    //    // The rest of your code for handling the form submission
    //}

    //const details = {
    //    numbercount: formValues.numbercount,
    //    pastquotes: formValues.pastquotes,
    //    currentutlization: formValues.currentutlization,
    //    numberram: formValues.numberram,
    //    sampricing: formValues.sampricing,
    //    deadlineDate: formValues.deadlineDate,
    //    selectedOption: formValues.selectedOption,
    //    session: formValues.session,
    //    pricingOption: formValues.pricingOption,
    //    utilizationNumber: formValues.utilizationNumber,
    //};

    //if (!details.numbercount || !details.pastquotes || !details.currentutlization || !details.numberram || !details.sampricing || !details.deadlineDate || !details.selectedOption || !details.session || !details.pricingOption || !details.utilizationNumber) {

    //    return;
    //}
  };
  const [selectedFile, setSelectedFile] = useState(null);
 
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
  };
  const handleReupload = () => {
    setSelectedFile(null);
  };
  function getFormattedToday() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  const closeNotificationPopup = () => {
    setShowNotification(false);
  };

  const handleEditButtonClick = () => {
    if (editMode) {
      setShowVariationAccordian(!showVariationAccordian);
      setEditMode(false);
    } else {
      setEditMode(true);
    }
  };

  const handleSelect2 = (priceselectValue) => {
    setFormValues((prevFormValues) => ({
      ...prevFormValues,
      pricingOption: priceselectValue,
    }));
  };
  const handleSelect3 = (options) => {};
  const handleSaveButtonClick = () => {
    setEditMode(true);
  };
  const handleConfirmButton = () => {
    setBannerHeading(2);
  };
  
  return (
    <>
      <Banner
        Heading={Constant.BANNER_HEADING}
        Paragraph={Constant.BANNER_PARAGRAPH}
        showBreadcrumb={true}
      />
      <Container maxWidth="xl">
        <CreateRequestWrapper>
          <div className="createrequestContainer">
            <div className="requestForm">
           { bannerHeading===0 && <Typography variant="h6">{Constant.FORM_HEADING1}</Typography>}
           { bannerHeading===1 && <Typography variant="h6"><img src={check} className="bannerimage"></img>{Constant.FORM_HEADING2}</Typography>}
           { bannerHeading===2 && <Typography variant="h6"><img src={check} className="bannerimage"></img>{Constant.FORM_HEADING3}</Typography>}
           {countryUploaded==null && <Box className="requestformLeft">
                <span>{Constant.SAMPLE}</span>
                <Button component="label" variant="contained">
                  Upload Countries
                  <VisuallyHiddenInput
                    type="file"
                    onChange={(e) => handleFile(e)}
                  />
                </Button>
              </Box>
            }
            {countryUploaded && 
            <Box className="requestformLeftTwo">
                <span>{countryUploaded.name}</span>
                <Button component="label" variant="text" className="btnreplace" startIcon={<RedoIcon className="iconone" />} size="small">
                  Replace
                  <VisuallyHiddenInput
                    type="file"
                    onChange={(e) => handleFile(e)}
                  />
                </Button> |
                <Button component="label" variant="text" className="btnview" startIcon={<RemoveRedEyeOutlinedIcon  className="icontwo"  />} size="small">
                  View
                </Button>
              </Box>
            }
              {/* ) : null} */}
            </div>
            {/* Country Excel DATA Accordion */}
            {bannerHeading==1 && <ValidationAccordionComp
              title={Constant.VALIDATION}
              subtitle={Constant.VALIDATION_SUBTITLE}
              headers={countrydataheader}
              rows={countrydata}
              countries={countrylist}
              handleConfirm={handleConfirmButton}
            />
            }
            {/* end */}

            {/* CMS DATA Accordion */}
            <AccordionComp 
              title={Constant.CRM_DATA}
              subtitle={Constant.ACCORDIAN_SUBTITLE}
              isDisabled={bannerHeading===1?true:false}
              exapndable={bannerHeading===2?true:false}
            >
              <Box className="formdataContainer">
                <div className="formdataField">
                  <label>Company Name to be quoted</label>
                  <TextField
                    disabled
                    className="formInput"
                    defaultValue={crmData.account}
                  />
                </div>
                <div className="formdataField">
                  <label>Opportunity ID</label>
                  <TextField
                    disabled
                    className="formInput"
                    defaultValue={crmData.opportunity}
                  />
                </div>
                <div className="formdataField">
                  <label>Pricing Type</label>
                  <TextField
                    disabled
                    className="formInput"
                    defaultValue={optype.cpqOpportunityType}
                  />
                </div>
                <div className="formdataField">
                  <label>Location of Buyer</label>
                  <TextField
                    disabled
                    className="formInput"
                    defaultValue={crmData?.billingCountry}
                  />
                </div>
                <div className="formdataField">
                  <label>Partner/Resellers</label>
                  <TextField
                    disabled
                    className="formInput"
                    defaultValue={crmData.wpo_memberoftext}
                  />
                </div>
                <div className="formdataField">
                  <label>Broker Consultant</label>
                  <TextField
                    disabled
                    className="formInput"
                    defaultValue={crmData.opportunityReferrerName}
                  />
                </div>
                <div className="formdataField">
                  <label>Broker Commission?</label>
                  <TextField
                    disabled
                    className="formInput"
                    defaultValue={crmData.isBroker}
                  />
                </div>
                <div className="formdataField">
                  <label>Broker Commission%</label>
                  <TextField
                    disabled
                    className="formInput"
                    defaultValue={crmData.commissionPercentage}
                  />
                </div>
                <div className="formdataField">
                  <label>Tota HC to be quoted</label>
                  <TextField
                    disabled
                    className="formInput"
                    value={sumHeadCounts}
                  />
                </div>
                <div className="formdataField">
                  <label>Currency Requested</label>
                  <TextField
                    disabled
                    className="formInput"
                    defaultValue={crmData.currencyCode}
                  />
                </div>
                <div className="formdataField">
                  <label>Account Subtype</label>
                  <TextField
                    disabled
                    className="formInput"
                    defaultValue={crmData.accountSubType}
                  />
                </div>
                {optype.cpqOpportunityType === "RENEWAL" && (
                  <div className="formdataField">
                    <label>Program Start Date</label>
                    <TextField
                      disabled
                      className="formInput"
                      defaultValue={moment(crmData.programStartDate).format(
                        "MM-DD-YYYY"
                      )}
                    />
                  </div>
                )}
              </Box>
            </AccordionComp>
            {/* end */}

            {/* Quote Detail Accordion */}
            <Box className="secondAccordian">
              <AccordionComp
                title={Constant.QUOTE_DETAILS}
                subtitle={Constant.ACCORDIAN_SUBTITLETWO}
                aria-required
                isDisabled={bannerHeading===1?true:false}
                exapndable={bannerHeading===2?true:false}
              >
                <Box className="formdataContainer">
                  {optype.cpqOpportunityType === "RENEWAL" && (
                    <div className="formdataFieldOne">
                      <label>{Constant.SECOND_ACCORDIAN_RENEWAL_LABEL1}</label>
                      <TextField
                        className="formInput"
                        placeholder="Type Here"
                        name="existingPartneredClientInfo"
                        onChange={handleChange}
                        value={formValues.existingPartneredClientInfo}
                      />
                    </div>
                  )}

                  <div className="formdataFieldTwo">
                    <label>{Constant.SECOND_ACCORDIAN_LABEL1}</label>
                    <Tooltip title={Constant.TOOLTIP_TITLE1}>
                      <InfoOutlinedIcon className="infoIcon" />
                    </Tooltip>
                    <TextField
                      className="formInputTwo"
                      placeholder="Type Here"
                      name="noOfLivesSavedByPartner"
                      onChange={handleChange}
                      value={formValues.noOfLivesSavedByPartner}
                    />
                    {/*<TextField*/}
                    {/*    label="Password"*/}
                    {/*    required*/}
                    {/*    value={value}*/}
                    {/*    onChange={(e) => setValue(e.target.value)}*/}
                    {/*    error={!value}*/}
                    {/*    helperText={!value ? "Require" : "Do not share your password"}*/}
                    {/*/>*/}
                  </div>
                  <div className="formdataFieldTwo">
                    <label>
                      {Constant.SECOND_ACCORDIAN_LABEL2}
                      <span className="red">*</span>
                    </label>
                    <Tooltip title={Constant.TOOLTIP_TITLE2}>
                      <InfoOutlinedIcon className="infoIcon" />
                    </Tooltip>
                    {/* <TextField
                                            className={`formInputTwo ${errors.numbercount ? 'errorInput' : ''} ${!errors.numbercount && formValues.numbercount ? 'correctInput' : ''}`}
                                            value={formValues.numbercount}
                                            onChange={handleChange}
                                            name="numbercount"
                                            placeholder="200..."

                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        {errors.numbercount && (
                                                            <ErrorOutlineOutlinedIcon color="error" fontSize="small" />
                                                        )}
                                                        {!errors.numbercount && formValues.numbercount && (
                                                            <CheckIcon color="success" fontSize="small" />
                                                        )}
                                                    </InputAdornment>
                                                ),
                                            }}
                                        /> */}

                    <TextField
                      className={`formInputTwo ${
                        errors.numbercount ? "errorInput" : ""
                      } ${
                        !errors.numbercount && formValues.numbercount
                          ? "correctInput"
                          : ""
                      }`}
                      value={
                        formValues.totalPotentialHeadCountOutside === 0
                          ? ""
                          : formValues.totalPotentialHeadCountOutside
                      }
                      onChange={handleChange}
                      name="totalPotentialHeadCountOutside"
                      placeholder="200..."
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            {errors.numbercount && (
                              <ErrorOutlineOutlinedIcon
                                color="error"
                                fontSize="small"
                              />
                            )}
                            {!errors.numbercount && formValues.numbercount && (
                              <CheckIcon color="success" fontSize="small" />
                            )}
                          </InputAdornment>
                        ),
                      }}
                    />
                    <Box>
                      {errors.numbercount && (
                        <span className="error">{errors.numbercount}</span>
                      )}
                    </Box>
                  </div>

                  <div className="formdataFieldThree">
                    <div className="d-flex">
                      <label>
                        {Constant.SECOND_ACCORDIAN_LABEL3}{" "}
                        <span>{Constant.IF_APPLICABLE}</span>
                        <Tooltip title={Constant.TOOLTIP_TITLE3}>
                          <InfoOutlinedIcon className="infoIcon" />
                        </Tooltip>
                      </label>
                    </div>
                    {selectedFile == null && (
                      <Button
                        size="medium"
                        component="label"
                        variant="outlined"
                        className="fileButton"
                        onChange={handleFileChange}
                      >
                        Choose File
                        <VisuallyHiddenInput type="file" />
                      </Button>
                    )}
                    {selectedFile != null && (
                      <div className="uploadFile">
                        <p className="fileName">
                          {selectedFile ? selectedFile.name : ""}
                        </p>

                        <Button
                          size="medium"
                          component="label"
                          variant="contained"
                          className="fileReButton"
                          onClick={handleReupload}
                        >
                          ReUpload
                        </Button>
                      </div>
                    )}
                  </div>
                  <div className="formdataFieldThree">
                    <label>
                      {Constant.SECOND_ACCORDIAN_LABEL4}{" "}
                      <span>{Constant.IF_APPLICABLE}</span>
                    </label>
                    <TextField
                      className="formInputThree"
                      placeholder="Type Here"
                      name="formalRFPNotes"
                      onChange={handleChange}
                      value={formValues.formalRFPNotes}
                    />
                  </div>
                  <div className="formdataFieldThree">
                    <label>{Constant.SECOND_ACCORDIAN_LABEL5}</label>
                    <TextField
                      className="formInputThree"
                      placeholder="Type Here"
                      name="competitorsBidders"
                      onChange={handleChange}
                      value={formValues.competitorsBidders}
                    />
                  </div>
                  {optype.cpqOpportunityType === "NEW" && (
                    <div className="formdataFieldThree">
                      <div className="d-flex">
                        <label>
                          {Constant.SECOND_ACCORDIAN_LABEL6}{" "}
                          <span className="red">*</span>
                          <Tooltip title={Constant.TOOLTIP_TITLE4}>
                            <InfoOutlinedIcon className="infoIcon" />
                          </Tooltip>
                        </label>
                      </div>
                      <TextField
                        className={`formInputThree ${
                          errors.pastquotes ? "errorInput" : ""
                        } ${
                          !errors.pastquotes && formValues.pastquotes
                            ? "correctInput"
                            : ""
                        }`}
                        value={formValues.pastQuotes}
                        onChange={handleChange}
                        name="pastQuotes"
                        placeholder="Type Here"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              {errors.pastquotes && (
                                <ErrorOutlineOutlinedIcon
                                  color="error"
                                  className="red"
                                  fontSize="small"
                                />
                              )}
                              {!errors.pastquotes && formValues.pastquotes && (
                                <CheckIcon color="success" fontSize="small" />
                              )}
                            </InputAdornment>
                          ),
                        }}
                      />
                      <Box>
                        {errors.pastquotes && (
                          <span className="error">{errors.pastquotes}</span>
                        )}
                      </Box>
                    </div>
                  )}
                  {optype.cpqOpportunityType === "NEW" && (
                    <div className="formdataFieldThree">
                      <div className="d-flex">
                        <label>
                          {Constant.SECOND_ACCORDIAN_LABEL7}
                          <span className="red">*</span>
                          <Tooltip title={Constant.TOOLTIP_TITLE5}>
                            <InfoOutlinedIcon className="infoIcon" />
                          </Tooltip>
                        </label>
                      </div>
                      <TextField
                        className={`formInputThreeSecond ${
                          errors.currentutlization ? "errorInput" : ""
                        } ${
                          !errors.currentutlization &&
                          formValues.currentutlization
                            ? "correctInput"
                            : ""
                        }`}
                        value={formValues.currentUtilizationWithOtherVendors}
                        onChange={handleChange}
                        name="currentUtilizationWithOtherVendors"
                        placeholder="Type Here"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              {errors.currentutlization && (
                                <ErrorOutlineOutlinedIcon
                                  color="error"
                                  fontSize="small"
                                />
                              )}
                              {!errors.currentutlization &&
                                formValues.currentutlization && (
                                  <CheckIcon color="success" fontSize="small" />
                                )}
                            </InputAdornment>
                          ),
                        }}
                      />
                      <Box>
                        {errors.currentutlization && (
                          <span className="error">
                            {errors.currentutlization}
                          </span>
                        )}
                      </Box>
                    </div>
                  )}
                  {optype.cpqOpportunityType === "NEW" && (
                    <div className="formdataFieldThree">
                      <label>
                        {Constant.SECOND_ACCORDIAN_LABEL8}{" "}
                        <span className="red">*</span>
                      </label>
                      <TextField
                        type="date"
                        className={`formInputThree ${
                          errors.deadlineDate ? "errorInput" : ""
                        } ${
                          !errors.deadlineDate && formValues.deadlineDate
                            ? "correctInput"
                            : ""
                        }`}
                        value={formValues.deadline}
                        onChange={handleChange}
                        name="deadline"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              {errors.deadlineDate && (
                                <ErrorOutlineOutlinedIcon
                                  color="error"
                                  fontSize="small"
                                />
                              )}
                              {!errors.deadlineDate &&
                                formValues.deadlineDate && (
                                  <CheckIcon color="success" fontSize="small" />
                                )}
                            </InputAdornment>
                          ),
                        }}
                        inputProps={{
                          min: getFormattedToday(), // You need to define getFormattedToday() function to get today's date in the correct format (YYYY-MM-DD).
                        }}
                      />

                      <Box>
                        {errors.deadlineDate && (
                          <span className="error">{errors.deadlineDate}</span>
                        )}
                      </Box>
                    </div>
                  )}
                  <div className="formdataFieldThree">
                    <label>
                      {Constant.SECOND_ACCORDIAN_LABEL9}
                      <span className="red">*</span>
                      <Tooltip title={Constant.TOOLTIP_TITLE6}>
                        <InfoOutlinedIcon className="infoIcon" />
                      </Tooltip>
                    </label>
                    <TextField
                      className={`formInputThree ${
                        errors.numberram ? "errorInput" : ""
                      } ${
                        !errors.numberram && formValues.numberram
                          ? "correctInput"
                          : ""
                      }`}
                      value={
                        formValues.noOfRAMs === 0 ? "" : formValues.noOfRAMs
                      }
                      onChange={handleChange}
                      name="noOfRAMs"
                      placeholder="1,2,3,..."
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            {errors.numberram && (
                              <ErrorOutlineOutlinedIcon
                                color="error"
                                fontSize="small"
                              />
                            )}
                            {!errors.numberram && formValues.numberram && (
                              <CheckIcon color="success" fontSize="small" />
                            )}
                          </InputAdornment>
                        ),
                      }}
                    />
                    <Box>
                      {errors.numberram && (
                        <span className="error">{errors.numberram}</span>
                      )}
                    </Box>
                  </div>
                  <div className="formdataFieldThree">
                    <div className="d-flex">
                      <label>
                        {Constant.SECOND_ACCORDIAN_LABEL10}
                        <Tooltip title={Constant.TOOLTIP_TITLE7}>
                          <InfoOutlinedIcon className="infoIcon" />
                        </Tooltip>
                      </label>
                    </div>
                    <TextField
                      className="formInputThree"
                      placeholder="Type Here"
                      value={formValues.locationRAMs}
                      onChange={handleChange}
                      name="locationRAMs"
                    />
                  </div>
                  {optype.cpqOpportunityType === "RENEWAL" && (
                    <div className="formdataFieldThree">
                      <label>{Constant.SECOND_ACCORDIAN_RENEWAL_LABEL2}</label>
                      <TextField
                        className="formInputThreeSecond"
                        placeholder="Type Here"
                        name="currentRateEffectiveOn"
                        onChange={handleChange}
                        value={formValues.currentRateEffectiveOn}
                      />
                    </div>
                  )}
                  {optype.cpqOpportunityType === "RENEWAL" && (
                    <div className="formdataFieldThree">
                      <label>{Constant.SECOND_ACCORDIAN_RENEWAL_LABEL3}</label>
                      <TextField
                        className="formInputThreeSecond"
                        placeholder="Type Here"
                        name="pastThreeYrRateHeadCount"
                        onChange={handleChange}
                        value={formValues.pastThreeYrRateHeadCount}
                      />
                    </div>
                  )}
                  {optype.cpqOpportunityType === "RENEWAL" && (
                    <div className="formdataFieldThree">
                      <label>{Constant.SECOND_ACCORDIAN_RENEWAL_LABEL5}</label>

                      <TextField
                        className="formInputThreeSecond"
                        placeholder="Type Here"
                        name="estimatedNoOfAMHrPerYear"
                        onChange={handleChange}
                        value={formValues.estimatedNoOfAMHrPerYear}
                      />
                    </div>
                  )}
                  {optype.cpqOpportunityType === "RENEWAL" && (
                    <div className="formdataFieldThree">
                      <label>{Constant.SECOND_ACCORDIAN_RENEWAL_LABEL4}</label>

                      <TextField
                        className="formInputThree"
                        placeholder="Type Here"
                        name="annualUtilizationThreeYrs"
                        onChange={handleChange}
                        value={formValues.annualUtilizationThreeYrs}
                      />
                    </div>
                  )}

                  <div className="formdataFieldThree">
                    <label>
                      {Constant.SECOND_ACCORDIAN_LABEL11}{" "}
                      <span className="red">*</span>
                      <Tooltip title={Constant.TOOLTIP_TITLE8}>
                        <InfoOutlinedIcon className="infoIcon" />
                      </Tooltip>
                      <TextField
                        className={`formInputThreeThird ${
                          errors.sampricing ? "errorInput" : ""
                        } ${
                          !errors.sampricing && formValues.sampricing
                            ? "correctInput"
                            : ""
                        }`}
                        value={formValues.samPriceRecommendAssumption}
                        onChange={handleChange}
                        name="samPriceRecommendAssumption"
                        placeholder="Type Here"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              {errors.sampricing && (
                                <ErrorOutlineOutlinedIcon
                                  color="error"
                                  fontSize="small"
                                />
                              )}
                              {!errors.sampricing && formValues.sampricing && (
                                <CheckIcon color="success" fontSize="small" />
                              )}
                            </InputAdornment>
                          ),
                        }}
                      />
                      <Box>
                        {errors.sampricing && (
                          <span className="error">{errors.sampricing}</span>
                        )}
                      </Box>
                    </label>
                  </div>
                  {optype.cpqOpportunityType === "RENEWAL" && (
                    <div className="formdataFieldThree">
                      <label>
                        {Constant.SECOND_ACCORDIAN_LABEL8}{" "}
                        <span className="red">*</span>
                      </label>
                      <TextField
                        type="date"
                        className={`formInputThree ${
                          errors.deadlineDate ? "errorInput" : ""
                        } ${
                          !errors.deadlineDate && formValues.deadlineDate
                            ? "correctInput"
                            : ""
                        }`}
                        value={formValues.deadline}
                        onChange={handleChange}
                        name="deadline"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              {errors.deadlineDate && (
                                <ErrorOutlineOutlinedIcon
                                  color="error"
                                  fontSize="small"
                                />
                              )}
                              {!errors.deadlineDate &&
                                formValues.deadlineDate && (
                                  <CheckIcon color="success" fontSize="small" />
                                )}
                            </InputAdornment>
                          ),
                        }}
                        inputProps={{
                          min: getFormattedToday(), // You need to define getFormattedToday() function to get today's date in the correct format (YYYY-MM-DD).
                        }}
                      />

                      <Box>
                        {errors.deadlineDate && (
                          <span className="error">{errors.deadlineDate}</span>
                        )}
                      </Box>
                    </div>
                  )}
                  <div className="formdataFieldThree">
                    <label>
                      {Constant.SECOND_ACCORDIAN_LABEL12}{" "}
                      <span className="red">*</span>
                    </label>
                    <div className="inputSelect">
                      {/*<CustomSelect*/}
                      {/*    options={productOptions}*/}
                      {/*    placeholder="Select an option"*/}
                      {/*    onSelect={handleSelect}*/}
                      {/*    className={`customDropdown ${errors.selectedOption ? 'errorInput' : ''} ${!errors.selectedOption && selectedOption ? 'correctInput' : ''*/}
                      {/*        }`}*/}
                      {/*    value={formValues.productId}*/}
                      {/*    onChange={handleChange}*/}
                      {/*    name="productId"*/}
                      {/*    InputProps={{*/}
                      {/*        endAdornment: (*/}
                      {/*            <InputAdornment position="end">*/}
                      {/*                {errors.selectedOption && <ErrorOutlineOutlinedIcon color="error" fontSize="small" />}*/}
                      {/*                {!errors.selectedOption && selectedOption && <CheckIcon color="success" fontSize="small" />}*/}
                      {/*            </InputAdornment>*/}
                      {/*        ),*/}
                      {/*    }}*/}
                      {/*/>*/}
                      <FormControl className="customDropdown">
                        <Select
                          value={formValues.productId}
                          name="productId"
                          onChange={handleSelectChange}
                          placeholder="Select Product"
                        >
                          <MenuItem value={0}>Select Product</MenuItem>
                          {productsList.map((option) => (
                            <MenuItem key={option.id} value={option.id}>
                              {option.productName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>

                      <Box>
                        {errors.selectedOption && (
                          <span className="error">{errors.selectedOption}</span>
                        )}
                      </Box>
                    </div>
                  </div>
                  <div className="formdataFieldThree">
                    <label>{Constant.SECOND_ACCORDIAN_LABEL13}</label>
                    <div className="inputSelect">
                      <FormControl className="customDropdown">
                        <Select
                          value={formValues.productVariationId}
                          name="productVariationId"
                          onChange={handleSelectChange}
                        >
                          <MenuItem value={0}>
                            Select Product Variation
                          </MenuItem>
                          {productVariationsList.map((option) => (
                            <MenuItem key={option.id} value={option.id}>
                              {option.productVariationName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                  {optype.cpqOpportunityType === "RENEWAL" && (
                    <div className="formdataFieldThree">
                      <FormGroup className="checkboxInput">
                        <FormControlLabel
                          control={<Checkbox onChange={handleClick} />}
                          label="Pricing Team Quote Review"
                        />
                      </FormGroup>
                    </div>
                  )}
                  {optype.cpqOpportunityType === "RENEWAL" &&
                    showCommentText && (
                      <div className="formdataFieldThree">
                        <label>
                          {Constant.SECOND_ACCORDIAN_RENEWAL_LABEL6}
                        </label>
                        <TextField
                          className="formInputThreeFour"
                          placeholder="Type Here"
                          name="existingPartneredClientInfo"
                          value={formValues.existingPartneredClientInfo}
                        />
                      </div>
                    )}
                </Box>
              </AccordionComp>
            </Box>
            {/* End */}

            {/* Variation Accordian */}

            <Box className="thirdAccordian">
              {showVariationAccordian && (
                <AccordionComp title="Variation">
                  <div className="thirdAccordianContainer">
                    <Typography variant="h6">{Constant.COMPONENTS}</Typography>
                    <Box className="d-flex">
                      {componentList.map((x) => (
                        <FormGroup className="checkboxInput" key={x.id}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={x.autoSelect}
                                disabled={x.autoSelect}
                              />
                            }
                            label={x.componentName}
                          />
                        </FormGroup>
                      ))}
                    </Box>
                  </div>
                  <div className="d-flex accordianBottom">
                    <Box className="bottomInputs">
                      <label>{Constant.SESSION}</label>
                      <TextField
                        className="formInputFour"
                        value={
                          formValues.sessions === 0 ? "" : formValues.sessions
                        }
                        onChange={handleChange}
                        placeholder="Type Here"
                        name="sessions"
                      />
                      <Box>
                        {errors.session && (
                          <span className="error">{errors.session}</span>
                        )}
                      </Box>
                    </Box>
                    <Box className="bottomInputs">
                      <label>{Constant.UTILIZATION}</label>
                      <TextField
                        className="formInputFour"
                        value={formValues.utilization}
                        onChange={handleChange}
                        name="utilization"
                      />
                      <Box>
                        {errors.utilization && (
                          <span className="error">{errors.utilization}</span>
                        )}
                      </Box>
                    </Box>
                    {optype.cpqOpportunityType === "RENEWAL" && (
                      <Box className="bottomInputs">
                        <label>{Constant.AMHOURS}</label>
                        <TextField
                          className="formInputFour"
                          value={formValues.amHours}
                          onChange={handleChange}
                          name="amHours"
                        />
                      </Box>
                    )}
                    <Box className="bottomInputs">
                      <label>{Constant.PRICING_STRUCTURE}</label>
                      <div className="bottomInputSelect">
                        <FormControl className="customDropdown">
                          <Select
                            value={formValues.pricingStructureId}
                            name="pricingStructureId"
                            onChange={handleSelectChange}
                          >
                            <MenuItem disabled value={0}>
                              Select Pricing Structure
                            </MenuItem>
                            {pricingStructureList.map((option) => (
                              <MenuItem key={option.id} value={option.id}>
                                {option.pricingStructureName}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        <Box>
                          {errors.pricingOption && (
                            <span className="error">
                              {errors.pricingOption}
                            </span>
                          )}
                        </Box>
                      </div>
                    </Box>
                    <CustomButton
                      buttonName={Constant.CALCULATE}
                      color="success"
                      onClick={handleCalculateClick}
                    />
                  </div>
                </AccordionComp>
              )}
            </Box>

            {/* end */}
          </div>
        </CreateRequestWrapper>

        {/* Utilization Distribution Table */}
        <ViewBoxWrapper>
          <Box className="viewTableContainer">
            <div className="d-flex">
              <Typography variant="h4">
                {Constant.UTILIZATION_DISTRIBUTION}
              </Typography>
              {editMode ? (
                <div className="editBtn">
                  <CustomButton
                    buttonName={Constant.EDIT}
                    icon={ModeEditIcon}
                    color="primary"
                    className="editBtn"
                    onClick={handleEditButtonClick}
                  />
                </div>
              ) : (
                <CustomButton
                  buttonName={Constant.SAVE}
                  icon={SaveIcon}
                  color="success"
                  onClick={handleSaveButtonClick}
                />
              )}
            </div>
          </Box>
          <Box className="viewTableContent">
            {/*<ViewTable headers={headers1} rows={rows1} />*/}
            <ServiceDistribution
              headers={utilizationDistributionHeaders}
              rows={utilizationDistributionRows}
            />
          </Box>
        </ViewBoxWrapper>

        {/* Pricing Calculation Section */}
        <CalculationWrapper>
          <Box className="calculationContainer">
            <Typography variant="h4">
              {Constant.PRICING_CALCULATION}{" "}
              <span>{Constant.ALL_IN_PRICE}</span>
            </Typography>
            <div className="calculationContent">
              <div className="d-flex">
                <div className="heading">
                  <Typography variant="h6">{pricingStructureLbl}</Typography>
                  <span>{pricingStructureVal}</span>
                </div>
                <div className="heading">
                  <Typography variant="h6">{pricingStructureUSDLbl}</Typography>
                  <span>{pricingStructureUSDVal}</span>
                </div>
              </div>
            </div>
          </Box>
        </CalculationWrapper>
      </Container>
      <Box>
        <FooterButtons
          leftButton={Constant.GO_BACK}
          onSubmitButton={handleSubmit}
          onRightButtonClick={handleSaveAsDraft}
          rightButtonTextOne={Constant.SAVE_DRAFT}
          leftButtonTextTwo={Constant.SUBMIT_VIEW}
        />
      </Box>
      {showNotification && (
        <Notification
          open={showNotification}
          onClose={closeNotificationPopup}
          message={notificationMessage}
          severity="success"
        />
      )}
    </>
  );
};

export default CountryUploadValidation;
